import { render } from "./DashboardDoctor.vue?vue&type=template&id=fc543650&scoped=true"
import script from "./DashboardDoctor.vue?vue&type=script&lang=ts"
export * from "./DashboardDoctor.vue?vue&type=script&lang=ts"

import "./DashboardDoctor.vue?vue&type=style&index=0&id=fc543650&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-fc543650"

export default script